import { RefundListWidget } from "@/widgets/refund/RefundListWidget";

export function RefundListPage() {
  return (
    <div className="page">
      <RefundListWidget />
    </div>
  );
}
